<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="ack"><a id="page_xv"></a><a href="#/xhtml/contents#ack">Acknowledgments</a></p>
<p class="Bodyflush">This book is gratefully and affectionately dedicated to the late Christian philosopher Stuart C. Hackett. His warm encouragement, daily prayers, faithful friendship, and philosophical rigor in his teaching, conversation, and writing instilled in me a love and appreciation for the task of philosophy.</p>
<p class="Body">Special thanks to my sister Lil Copan. She strongly urged me to consider Eerdmans while I was upgrading and revising <i>Loving Wisdom</i> for a second edition (it had been published by Chalice Press the first go-round).</p>
<p class="Body">As this book has evolved, I appreciate helpful comments from Chad Meister, Christopher Weaver, Charles Taliaferro, and Peter Frick—not to mention my philosophy of religion students, who have offered their own perspectives and questions along the way.</p>
<p class="Body">Thanks to my graduate assistant Liezl Bosch, who has read through and commented on the manuscript. She has also written the study questions to guide small group discussions, included at the back of the book.</p>
<p class="Body">I am grateful to Palm Beach Atlantic University for granting me a splendid sabbatical in 2017—and to Oxford University’s Wycliffe Hall, where I was a visiting scholar (“academic visitor”) during the Hilary and Trinity terms. There I began work on this second edition. I am grateful for the warm hospitality, friendships, and kindnesses experienced there.</p>
<p class="Body">I appreciate the editing suggestions of Jenny Hoffman at Eerdmans. Her comments have assisted in making this book clearer and smoother.</p>
<p class="Body">Robust thanks to my beloved wife, Jacqueline, for her sweet partnership and unstinting support in this and other book-writing and -editing endeavors.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?cbbeba5c